import React, { useState } from "react";
import Joi from "joi-browser";

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogBody,
} from "../../../common/dialog";
import { Button } from "../../../common/button";
import { Field, ErrorMessage, Label } from "../../../common/fieldset";
import { Input } from "../../../common/input";

import * as projectService from "../../../services/projectService";
import { showErrorToast } from "V2.0/utils";

import { message } from "antd";

export function RenameWorkspace(props) {
  const { isOpen, onClose, project, fetchProjects } = props;

  const [inputField, setInputField] = useState({
    "Workspace name": project?.name,
  });

  const [error, setError] = useState({
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const { error } = Joi.validate(inputField, {
      "Workspace name": Joi.string().min(3).max(45),
    });
    if (error) {
      setError({ message: error.details[0].message });
      return true;
    }
    setError({ message: "" });
    return false;
  };

  const handleSubmit = async () => {
    if (validate()) {
      return;
    }
    setLoading(true);
    message.loading("Renaming Workspace");

    try {
      const response = await projectService.updateProject(project?._id, {
        name: inputField["Workspace name"],
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Workspace renamed");
        setLoading(false);
        fetchProjects();
      }
    } catch (e) {
      message.destroy();
      setLoading(false);
      showErrorToast(e, "Failed to rename workspace");
    }
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} size="lg">
      <DialogTitle className="text-md">Rename workspace</DialogTitle>
      <DialogBody>
        <Field>
          <Label>Workspace Name</Label>
          <Input
            type="text"
            minLength={3}
            maxLength={45}
            value={inputField["Workspace name"]}
            onChange={(e) => {
              if (error.message) {
                setError({ message: "" });
              }
              setInputField({ "Workspace name": e.target.value });
            }}
          />
          <ErrorMessage>{error.message}</ErrorMessage>
        </Field>
      </DialogBody>
      <DialogActions>
        <Button plain onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          loading={loading}
          disabled={!!error.message || loading}
        >
          Rename
        </Button>
      </DialogActions>
    </Dialog>
  );
}
